module.exports = __webpack_public_path__ + "img/qa.d0676975.png";